import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Shop } from "../../models/shop.model";

@Injectable()
export class ShopProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<Shop> {
    return this.http
      .get<Shop>(`${this.url}/shops/${id}`)
      .map(response => {
        return new Shop(response);
      })
      .catch(this.handleError)
  }

  getAllByRetailerID(retailerID: number): Observable<Shop[]> {
    return this.http
      .get<Shop[]>(`${this.url}/shops/retailer/${retailerID}`)
      .map(response => {
        return response.map((shop) => new Shop(shop));
      })
      .catch(this.handleError);
  }

  getAllByCountryID(countryID: number): Observable<Shop[]> {
    return this.http
      .get<Shop[]>(`${this.url}/shops/country/${countryID}`)
      .map(response => {
        return response.map((shop) => new Shop(shop));
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/shop/shop.ts